import { createSelector } from 'reselect';
import cloneDeep from 'lodash/cloneDeep';
import { campaignState, quoteState } from '../selectors';

export const makeCampaignRows = (campaignLines, bookingCampaign) =>
  cloneDeep(campaignLines).map((campaign) => {
    const { operationId, discount, coupon, title, type } = campaign;
    const row = {
      // ...campaign,
      workSummary: `${type === 'discount' ? 'Discount' : 'Coupon'}: ${title}`,
      fixedCostWithVAT: discount ? `${discount * -100}%` : coupon / 100,
      key: `discount-row-${operationId}`,
      type,
      discount,
      coupon,
      className: ['discount-row', 'footer-row'],
      editable: false,
      appliedToCheckout: bookingCampaign?.appliedToCheckout,
      appliedToEWO: bookingCampaign?.appliedToEWO,
    };
    return row;
  });

export default function campaignSelector() {
  return createSelector(quoteState, campaignState, (quote, campaign) => {
    if (!quote) return [];
    const campaignLines = quote
      .get('lineItems')
      .filter((li) => ['coupon', 'discount'].includes(li.get('type')))
      .toJS();
    if (!campaign) {
      return makeCampaignRows(
        campaignLines.filter((li) => li.source === 'MOT-BUNDLE'),
        null
      );
    }
    return makeCampaignRows(
      campaignLines,
      campaign.toJS()
    );
  });
}
